// Canonical tenant/resource role values shared by LeMans Home UI and Common Admin.
export enum Role {
  Navigator = 'Navigator',
  Reader = 'Reader',
  Contributor = 'Contributor',
  Admin = 'Admin',
  Owner = 'Owner',
  BillingAdmin = 'BillingAdmin',
}
